<template>
    <button type="button" @click="onInputChange" :disabled="isSelected" :class="`${isSelected ? 'border border-primary text-primary' : 'text-[#C1C1C1]'} !outline-none cursor-default border px-2.5 py-2 md:px-3 md:py-3 xl:py-[0.86rem]  bg-white text-[13px] rounded-[4px]`"
        :for="typeOption.value">
        <span class="flex flex-nowrap items-center gap-2">
            <span class="grid place-content-center bg-white border border-[#C1C1C1] rounded-full w-[0.938rem] h-[0.938rem]">
                <span v-show="isSelected" class="bg-[#0963FF] w-[0.438rem] h-[0.438rem] rounded"/>
            </span>
            <span class="text-inherit">{{ typeOption.text }}</span>
        </span>
    </button>
</template>

<script>
export default {
    data(){
        return {
            hasFocus: false,
        }
    },
    props: {
        selectedProductTypeId: {
            type: String,
            default: true,
            required: false
        },
        typeOption: {
            type: Object,
            default: false,
            required: false
        }
    },
    methods: {
        onInputChange(){
            if(this.isSelected) return;
            this.$emit('onProductTypeFilterChange', this.typeOption.value);
        }
    },
    computed: {
        isSelected(){
            return this.selectedProductTypeId == this.typeOption.value;
        }
    },
}
</script>

<style></style>